export default [
    {
        key: "operation",
        label: "Operation",
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "user",
        label: "user",
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "created_at",
        label: "created at",
        thClass: "text-center",
        tdClass: "text-center",
    }
]